namespace advisorop.components.investor {

    interface IInvestorDashboardController {
        $router;
    }

    class InvestorDashboardController implements IInvestorDashboardController {

        $router;
        public investor: domains.IInvestor;

        //public holdingsByHhCharts: domains.IChartDataSource[] = [{
        //    chart: {
        //        caption: "...", numberPrefix: "", subCaption: "", theme: ""
        //    },
        //    data: []
        //}];

        //public dsAumChart: domains.IChartDataSource = {
        //    chart: {
        //        caption: "", numberPrefix: "", subCaption: "", theme: ""
        //    },
        //    data: []
        //};

        static $inject = ["investorService", "generalService"];
        constructor(private invSrv: services.InvestorService,
            private gs: services.GeneralService
        ) {
        }

        //loadDsAumChart() {
        //    this.invSrv.getMarketValues().then((data) => {

        //        this.dsAumChart = data.data;

        //        this.dsAumChart.chart.outCnvBaseFontSize = "14";
        //        this.dsAumChart.chart.showValues = "0";
        //        this.dsAumChart.chart.valuePadding = "-25";
        //        this.dsAumChart.chart.yAxisValuesStep = "1";
        //        this.dsAumChart.chart.valueFontSize = "14";
        //        this.dsAumChart.chart.rotateValues = "0";
        //        this.dsAumChart.chart.numberPrefix = "$";
        //        this.dsAumChart.chart.yAxisName = "AUM ($ Millions)";
        //        //this.dsAumChart.chart.subCaption = "$ Millions";

        //        if (this.dsAumChart.data && this.dsAumChart.data.length > 0)
        //            this.dsAumChart.data[this.dsAumChart.data.length - 1].showValue = "1";

        //        console.log(`AUM values: ${this.dsAumChart}`, this.dsAumChart);

        //    }).catch((response) => {
        //        toastr.error("Market data error: " + response.status + ":" + response.data);
        //    });
        //}

        //loadHoldingsByHhCharts() {
        //    this.invSrv.getHoldingsByHhCharts().then(data => {
        //        this.holdingsByHhCharts = data.data;
        //        console.log('Holdings by HH chart data', this.holdingsByHhCharts);
        //    }, err => this.gs.showError(err));
        //}

        loadInvestor() {
            this.invSrv.getInvestor().then(data => this.investor = data.data, err => this.gs.showError(err));
        }
        
        $onInit(): void {
            this.loadInvestor();
            //this.loadDsAumChart();
            //this.loadHoldingsByHhCharts();
        }

        $routerOnActivate(next, previous) {
        }
    }



    class InvestorDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                //textBinding: '@',
                //dataBinding: '<',
                //functionBinding: '&'
                "$router": "<"
            };
            this.controller = InvestorDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/investor-dashboard.html';
        }
    }
    angular.module(Constants.APP).component("investorDashboard", new InvestorDashboard());


}